import { RootState } from 'editor/src/store/index';

const getResultsVersion = (state: RootState) => state.editorModules.addons.data?.resultsVersion;

export default getResultsVersion;
